import { FormControl, FieldInput } from 'components/atoms';
import { HelpText } from 'components/organisms/other-information/OtherInformation.styles';
import { InitiateDueDiligenceFormFields } from 'pages/initiate-due-diligence/Initiate-due-diligence-form/InitiateDueDiligenceForm';
import { ReactComponent as InfoIcon } from '../../assets/svg/Icons/Info.svg';
import React from 'react';
import { FieldErrors, UseFormRegister } from 'react-hook-form';

type CbiInterviewInvitationTypes = {
  register: UseFormRegister<InitiateDueDiligenceFormFields>;
  formValidationErrors: FieldErrors<InitiateDueDiligenceFormFields>;
};

const CbiInterviewInvitation = ({
  register,
  formValidationErrors,
}: CbiInterviewInvitationTypes) => {
  return (
    <>
      <HelpText>
        <span style={{ marginRight: 8 }}>
          <InfoIcon />
        </span>
        <span>
          Once you submit the order the email will receive an automatic invitation to schedule a
          video interview
        </span>
      </HelpText>
      <div style={{ width: '400px' }}>
        <FormControl errorMessage={formValidationErrors?.applicantEmailAddress?.message}>
          <FieldInput
            fullWidth
            name="applicantEmailAddress"
            id="applicantEmailAddress"
            required={true}
            register={register}
            label="Applicant email address"
            valid={!formValidationErrors?.applicantEmailAddress}
          />
        </FormControl>
        <FormControl
          errorMessage={formValidationErrors?.applicantEmailAddressConfirmation?.message}
        >
          <FieldInput
            fullWidth
            name="applicantEmailAddressConfirmation"
            id="applicantEmailAddressConfirmation"
            required={true}
            register={register}
            label="Confirm email"
            valid={!formValidationErrors?.applicantEmailAddressConfirmation}
          />
        </FormControl>
      </div>
    </>
  );
};

export default CbiInterviewInvitation;
